import { makeRequestService } from '@vatsim-petersburg/utils';
import { BOOKINGS_BASE_URL } from '@/constants/constants';

export const bookingsRequestService = makeRequestService(BOOKINGS_BASE_URL);
